module.exports = __webpack_public_path__ + "bnbproject/img/AirNFT.856ce578.jpg";